export var ADDABLE_FILE_PROVIDERS_LIST = Object.freeze([
    1 /* OneDriveConsumer */,
    3 /* Box */,
    2 /* Dropbox */,
    6 /* Facebook */,
    5 /* GDrive */,
]);
//# sourceMappingURL=constants.js.map